/**
 * Embedded Tools Registry
 * Export all embedded React components here
 */
import React from "react";
import { ClientMap } from "./ClientMap";
import { CADAnalysis } from "./CADAnalysis";
import { CRM } from "./CRM";
import { SharePointQA } from "./SharePointQA";
import { Finance } from "./Finance";
import { SupportInsights } from "./SupportInsights";
import { JiraAssistant } from "./JiraAssistant";
import { ExecutiveDashboard } from "./executive/ExecutiveDashboard";
import { Conferences } from "./Conferences";

// Named exports for direct imports
export { ClientMap, CADAnalysis, CRM, SharePointQA, Finance, SupportInsights, JiraAssistant, ExecutiveDashboard, Conferences };

// Map of tool IDs to their components for dynamic loading
export const embeddedComponents: Record<string, React.ComponentType> = {
  "client-map": ClientMap,
  "cad-analysis": CADAnalysis,
  "crm": CRM,
  "sharepoint-agent": SharePointQA,
  finance: Finance,
  "support-insights": SupportInsights,
  "jira-agent": JiraAssistant,
  "executive-dashboard": ExecutiveDashboard,
  conferences: Conferences,
};
